import { useMediaQuery } from 'react-responsive';

import { BREAKPOINT } from '../../constants/breakpoint';

export const useDesktopMediaQuery = () =>
    useMediaQuery({ minWidth: BREAKPOINT.lg });

export const useTabletMediaQuery = () =>
    useMediaQuery({ minWidth: BREAKPOINT.md, maxWidth: BREAKPOINT.lg - 1 });

export const useMobileMediaQuery = () =>
    useMediaQuery({ maxWidth: BREAKPOINT.md - 1 });

export const useXXLMediaQuery = () =>
    useMediaQuery({ minWidth: BREAKPOINT.xxl + 1 });

export const useXLMediaQuery = () =>
    useMediaQuery({ minWidth: BREAKPOINT.xl, maxWidth: BREAKPOINT.xxl });

export const useTabletLargeMediaQuery = () =>
    useMediaQuery({ minWidth: BREAKPOINT.lg, maxWidth: BREAKPOINT.xl - 1 });

export const useTabletToSmallDesktopMediaQuery = () =>
    useMediaQuery({ minWidth: BREAKPOINT.md, maxWidth: BREAKPOINT.xl - 1 });
